import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Flex, HStack } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import DropdownMenu from '../../../../../../components/DropdownMenu';
import FormInput from '../../../../../../components/form/FormInput';
import InputLabel from '../../../../../../components/form/InputLabel';
import { analyticsIds } from '../../../../../../constants/analyticsIds';
import { countries } from '../../../../../../constants/countries';
import { getValidationObject } from '../../../../../../constants/regexPatterns';
import { selectStagedInsuredCountry, stageInsuredCountry } from '../../../../../../redux/modules/insured';
import UseFormMethodsType from '../../../../../../types/UseFormMethodsType';
import FormCollapse from '../FormCollapse';

function InsuredContactSection({ useFormMethods }) {
  const [contactOpen, setContactOpen] = useState(false);
  const dispatch = useDispatch();
  const insuredCountry = useSelector(selectStagedInsuredCountry);

  useEffect(() => dispatch(stageInsuredCountry({ code: 'US', name: 'United States'})), []); // eslint-disable-line

  const handleCountrySelect = selected => {
    dispatch(stageInsuredCountry({ code: selected.value, name: selected.label }));
  };

  return (
    <FormCollapse
      dusk="insuredContactCollapse"
      isOpen={contactOpen}
      title="Contact Information"
      toggle={() => setContactOpen(!contactOpen)}
    >
      <Box width="400px">
        <FormInput
          disableEnterKey
          dataAnalyticsId={analyticsIds.insuredsListPage.createInsuredForm.addressInput}
          inputName="insuredAddress"
          labelName="Address"
          placeholder="100 Main Street, #100"
          useFormMethods={useFormMethods}
        />

        <Flex>
          <FormInput
            disableEnterKey
            dataAnalyticsId={analyticsIds.insuredsListPage.createInsuredForm.cityInput}
            inputName="insuredCity"
            labelName="City"
            mr={2}
            placeholder="Somewhere"
            useFormMethods={useFormMethods}
            validationRules={getValidationObject('alphaAndCharacters')}
          />
          <FormInput
            disableEnterKey
            dataAnalyticsId={analyticsIds.insuredsListPage.createInsuredForm.stateInput}
            inputName="insuredState"
            labelName="State"
            placeholder="CA"
            useFormMethods={useFormMethods}
            validationRules={{ maxLength: { value: 2, message: "State's 2-letter abbreviation" } }}
          />
        </Flex>

        <Flex>
          <FormInput
            disableEnterKey
            dataAnalyticsId={analyticsIds.insuredsListPage.createInsuredForm.postalCodeInput}
            inputName="insuredZip"
            labelName="Postal Code"
            mr={2}
            placeholder="00000-0000"
            useFormMethods={useFormMethods}
            validationRules={{ maxLength: { value: 10, message: 'Postal code must be 10 characters or less' },
              ...getValidationObject('zipCode') }}
          />
          <Box mb="26px">
            <InputLabel labelName="Country" />
            <DropdownMenu
              dataAnalyticsKey={analyticsIds.insuredsListPage.createInsuredForm.countryInput}
              idKey="code"
              labelKey="name"
              options={countries}
              selected={insuredCountry && insuredCountry.name}
              width="196px"
              onSelect={handleCountrySelect}
            />
          </Box>
        </Flex>

        <HStack>
          <FormInput
            disableEnterKey
            dataAnalyticsId={analyticsIds.insuredsListPage.createInsuredForm.primaryPhoneInput}
            inputName="insuredPhone"
            labelName="Primary Phone"
            placeholder="(555) 555-555"
            type="phoneNumber"
            useFormMethods={useFormMethods}
          />
          <FormInput
            disableEnterKey
            dataAnalyticsId={analyticsIds.insuredsListPage.createInsuredForm.secondaryPhoneInput}
            inputName="insuredPhone2"
            labelName="Secondary Phone"
            placeholder="(555) 555-555"
            type="phoneNumber"
            useFormMethods={useFormMethods}
          />
        </HStack>
      </Box>

    </FormCollapse>
  );
}

InsuredContactSection.propTypes = {
  useFormMethods: UseFormMethodsType
};

export default InsuredContactSection;
